module.exports = __webpack_public_path__ + "static/media/zoom-out.70530934.svg";